module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/osago-promotion-mobile-f7ae0140b50b80b9609ba3e751013d66.png";